import { render } from "./SidebarUserCard.vue?vue&type=template&id=369fb350&scoped=true"
import script from "./SidebarUserCard.vue?vue&type=script&lang=js"
export * from "./SidebarUserCard.vue?vue&type=script&lang=js"

import "./SidebarUserCard.vue?vue&type=style&index=0&id=369fb350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369fb350"]])

export default __exports__